import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Management',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Management',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Management',
    column_type: 'datetime',
  },
  open_day: {
    model_name: 'Management',
    column_type: 'string',
  },
  allot_day: {
    model_name: 'Management',
    column_type: 'string',
  },
  redeem_day: {
    model_name: 'Management',
    column_type: 'string',
  },
  transaction_process: {
    model_name: 'Management',
    column_type: 'string',
  },
  allot_threshold: {
    model_name: 'Management',
    column_type: 'string',
  },
  redeem_limit: {
    model_name: 'Management',
    column_type: 'string',
  },
  raise_account: {
    model_name: 'Management',
    column_type: 'text',
  },
  investment_scope: {
    model_name: 'Management',
    column_type: 'text',
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
